export function isFileData(f) {
    return f !== null && typeof f === 'object' && f.originalFilename && f.base64;
}
export function toFile(f) {
    const byteCharacters = atob(f.base64);
    const byteNumbers = new Array(byteCharacters.length);
    for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
    }
    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray]);
    return new File([blob], f.originalFilename, { type: 'text/plain' });
}
export function toFileList(f) {
    const dataTransfer = new DataTransfer();
    if (isFileData(f)) {
        f = toFile(f);
    }
    if (f instanceof File) {
        dataTransfer.items.add(f);
    }
    return dataTransfer.files;
}
export function toEmptyFileList() {
    const dataTransfer = new DataTransfer();
    return dataTransfer.files;
}
export function toString(value) {
    if (value instanceof Set) {
        return Array.from(value).map((v) => toString(v)).join(', ');
    }
    if (value === true) {
        return 'on';
    }
    if (!value && value !== 0) {
        return '';
    }
    if (value instanceof File) {
        return value.name;
    }
    return String(value);
}
export function toArray(value) {
    if (value === undefined || value === null || value instanceof File || typeof value === 'string' || typeof value === 'number' || value === true || value === false) {
        return [];
    }
    if (typeof value === 'object' && Object.hasOwnProperty.call(value, 0)) {
        const result = [];
        for (let counter = 0; Object.hasOwnProperty.call(value, counter); counter++) {
            result.push(value[counter]);
        }
        return result;
    }
    return Array.from(value);
}
export function clone(value) {
    if (value === null) {
        return null;
    }
    if (typeof value !== 'object' || value instanceof File) {
        return value;
    }
    if (Array.isArray(value)) {
        const newArray = [];
        for (let i = 0; i < value.length; i++) {
            newArray[i] = clone(value[i]);
        }
        return newArray;
    }
    const newObject = {};
    Object.keys(value).forEach((key) => {
        newObject[key] = clone(value[key]);
    });
    return newObject;
}
export function createErrorMessage(constraint, value) {
    const $testFn = constraint.inverseCheck ? (r) => !r : (r) => Boolean(r);
    const isSingleMessage = typeof constraint.message === 'string';
    const messages = isSingleMessage ? [constraint.message] : [];
    if (!isSingleMessage) {
        Object.entries(constraint.message).forEach(([_key, value]) => {
            messages.push(value);
        });
    }
    if ($testFn(constraint.exactMatch === value)) {
        return messages.length > 0 ? messages.join("\n") : null;
    }
    if (constraint.pattern && $testFn(!new RegExp(constraint.pattern).test(toString(value)))) {
        return messages.length > 0 ? messages.join("\n") : null;
    }
    return null;
}
export function findInShadowDoms(selector, element = document.body) {
    var _a, _b;
    const found = element === null || element === void 0 ? void 0 : element.querySelector(selector);
    if (found) {
        return found;
    }
    if ('shadowRoot' in element) {
        const shadow = element.shadowRoot;
        if (shadow) {
            const found = findInShadowDoms(selector, shadow);
            if (found) {
                return found;
            }
        }
    }
    for (let i = 0; i < ((_b = (_a = element === null || element === void 0 ? void 0 : element.children) === null || _a === void 0 ? void 0 : _a.length) !== null && _b !== void 0 ? _b : 0); i++) {
        const child = element.children[i];
        const found = findInShadowDoms(selector, child);
        if (found) {
            return found;
        }
    }
    return null;
}
//# sourceMappingURL=utils.js.map
